import styled from 'styled-components';

export const InvoiceListWrapper = styled.div`
    width: 100%;
    max-width: 800px;
    margin: 50px auto;
`;